/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import Api, { ApiStatus } from "../Api";

import CpeDataProvider, { CPEBucket, CpeQueryPart } from "./CpeDataProvider";

export default class CpeDataProviderDefault implements CpeDataProvider {


   constructor(
      private api: Api
   ) { }


   public listVendors(vendor?: string, after?: string, size?: number): Observable<string[]> {

      if (this.api.status !== ApiStatus.Ready) throw new Error("API not initialized");

      const search = {
         name: vendor,
         after,
         size
      }

      return this.api.call<void, { vendors: string[] }>("/search/vendors", search).pipe(
         map(value => value.vendors)
      );

   }


   public listProducts(vendor: string, product?: string, after?: string, size?: number): Observable<string[]> {

      if (this.api.status !== ApiStatus.Ready) throw new Error("API not initialized");

      const search = {
         product,
         after,
         size
      }

      return this.api.call<void, { products: string[] }>(`/search/vendors/${vendor}`, search).pipe(
         map(value => value.products)
      );

   }


   public listCpePart(vendor: string, product: string, cpePart: CpeQueryPart, query?: string, after?: string, size?: number): Observable<string[]> {

      if (this.api.status !== ApiStatus.Ready) throw new Error("API not initialized");

      const search = {
         query,
         after,
         size
      }

      return this.api.call<void, { partList: string[] }>(`/search/vendors/${vendor}/${product}/${cpePart}`, search).pipe(
         map(value => value.partList)
      );

   }


   public getCpes(vendor?: string, product?: string, version?: string, from?: number, size?: number): Observable<CPEBucket> {

      if (this.api.status !== ApiStatus.Ready) throw new Error("API not initialized");

      const search = {
         vendor,
         product,
         version,
         from,
         size
      }

      return this.api.call<void, CPEBucket>(`/search/cpes`, search)

   }


}

